/** Public contact email shown in legal pages and support copy. */
export const CONTACT_EMAIL = "admin@chatisafe.com";
